export enum LoginCallbackState {
  InvalidAccessToken = 'INVALID_ACCESS_TOKEN',
  AccountDeleted = 'ACCOUNT_DELETED',
  EmailNotVerified = 'EMAIL_NOT_VERIFIED',
  NoAccessToken = 'NO_ACCESS_TOKEN',
  /** 
   * this error is thrown in one ot the Auth0 rules and points to the case when 
   * member exists in our DB but there is no link to external providers like Auth0 or Agents
   */
  ProfileError = 'PROFILE_ERROR',
  /** this is the error that our rules on Auth0 throw */
  UserExists = 'USER_EXISTS',
  /** this is the error returned bu Auth0 logic */
  UserEmailExists = 'GeneralError.UserEmailAlreadyExists',
  GeneralLoginError = 'LOGIN_ERROR',
  /** an error that happens when fail to exchange 'code' to 'access token' */
  ExchangeCodeError = 'EXCHANGE_CODE_ERROR',
  /** could not save data to a cookie */
  CookiesDisabledError = 'COOKIES_DISABLED_ERROR',
  NoErrors = 'NO_ERRORS'
}
